export default __webpack_public_path__ + "static/media/camera.ad653212.png";